export default __webpack_public_path__ + "static/media/rudolstadt-s.ec299738.webp";